/* src/app/weighbridge/modals/set-weight-modal/set-weight-modal.component.scss */
/*# sourceMappingURL=set-weight-modal.component.css.map */
